export const STABLE_ID_COOKIE_NAME = "posthog_stable_id";

export const FLAG_SERVER_SIDE_MCP_PREVIEW = "server-side-mcp-preview";
